import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../../../routes";
import {
  ButtonSecondary,
  GelContentContainer,
  HeroBlock,
  Notice,
  Controls,
  Notices,
  Role,
  FormErrorSummary,
  FormWrap,
  InputLanguageSwitcher,
  Loading
} from "cw-styleguide-react";

import ContactsCreateEditForm from "../components/ContactsCreateEditForm";

import {
  ACTION_PUBLISH,
  ACTION_QA,
  ACTION_SAVE,
  OPERATION_EDIT,
  ROLE_PROVIDER,
  ROLE_STAFF,
} from "../../../constants";
import withAssets from "../../../components/hoc/withAssets";

class ContactsEditView extends Component {
  /**
   * render.
   * @returns {JSX.Element}
   */
  render() {
    if (this.props.isLoadingContact) {
      return <Loading inline={true} />
    }

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t("local:view.contacts.edit.title")}</title>
        </Helmet>

        <BreadcrumbsItem
          to={
            route("contactsManage") +
            "/" +
            route("contactsEdit", { contact: this.props.values.id })
          }
        >
          {this.props.t("view.contacts.edit.breadcrumb")}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t("local:view.contacts.edit.title")}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>{this.props.t("local:view.contacts.edit.introduction")}</p>
        </HeroBlock>

        <GelContentContainer>
          {!this.props.loaded ? (
            <>
              {Object.keys(this.props.formErrors).length > 0 ? (
                <FormErrorSummary errors={this.props.formErrors} />
              ) : (
                <Notice type={"warning-alert"}>
                  {this.props.t("styleguide:messages.error204")}
                </Notice>
              )}
            </>
          ) : (
            <Fragment>
              <Notices messages={this.props.messages} />
              <FormErrorSummary
                errors={this.props.formErrors}
                handleErrorClick={this.props.handleErrorClick}
              />

              <FormWrap noPadding={true} noBackground={true}>
                <Controls>
                  {/* Controls */}
                  <ButtonSecondary
                    url={route("contactsManage") + this.props.query}
                    title={this.props.t(
                      "local:view.contacts.manage.controls.cancel"
                    )}
                  >
                    {this.props.t("local:view.contacts.manage.controls.cancel")}
                  </ButtonSecondary>
                  <ButtonSecondary
                    onClick={() => {
                      this.props.saveContact(
                        this.props.getSaveState(
                          this.props.values.status,
                          ACTION_SAVE
                        )
                      );
                    }}
                    title={this.props.t(
                      "local:view.contacts.manage.controls.save"
                    )}
                  >
                    {this.props.t("local:view.contacts.manage.controls.save")}
                  </ButtonSecondary>
                  <Role roles={[ROLE_PROVIDER]}>
                    <ButtonSecondary
                      onClick={() => {
                        this.props.saveContact(
                          this.props.getSaveState(
                            this.props.values.status,
                            ACTION_QA
                          )
                        );
                      }}
                      title={this.props.t(
                        "local:view.contacts.manage.controls.qa"
                      )}
                    >
                      {this.props.t("local:view.contacts.manage.controls.qa")}
                    </ButtonSecondary>
                  </Role>
                  <Role roles={[ROLE_STAFF]}>
                    <ButtonSecondary
                      onClick={() => {
                        this.props.saveContact(
                          this.props.getSaveState(
                            this.props.values.status,
                            ACTION_PUBLISH
                          )
                        );
                      }}
                      title={this.props.t(
                        "local:view.contacts.manage.controls.publish"
                      )}
                    >
                      {this.props.t(
                        "local:view.contacts.manage.controls.publish"
                      )}
                    </ButtonSecondary>
                    <ButtonSecondary
                      onClick={() => {
                        this.props.toggleModal(["delete"], true);
                      }}
                      title={this.props.t(
                        "local:view.contacts.create.controls.delete"
                      )}
                    >
                      {this.props.t(
                        "local:view.contacts.create.controls.delete"
                      )}
                    </ButtonSecondary>
                  </Role>
                  <ButtonSecondary
                    onClick={() => {
                      this.props.toggleModal(["archive"], true);
                    }}
                    title={this.props.t(
                      "local:view.contacts.create.controls.archive"
                    )}
                  >
                    {this.props.t(
                      "local:view.contacts.create.controls.archive"
                    )}
                  </ButtonSecondary>
                  <ButtonSecondary
                    onClick={() => {
                      this.props.toggleModal(["rollback"], true);
                    }}
                    title={this.props.t(
                      "local:view.contacts.create.controls.rollback"
                    )}
                  >
                    {this.props.t(
                      "local:view.contacts.create.controls.rollback"
                    )}
                  </ButtonSecondary>
                </Controls>
                <Controls>
                  {/* Language switcher */}
                  <InputLanguageSwitcher
                    language={this.props.inputLanguage}
                    onChange={this.props.handleSetInputLanguage}
                  />
                </Controls>
              </FormWrap>
              <h2>
                {this.props.values["contactName_" + this.props.inputLanguage]}
              </h2>
              <ContactsCreateEditForm {...this.props} mode={OPERATION_EDIT} />
            </Fragment>
          )}
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withAssets(withTranslation("local")(ContactsEditView));
